var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as cn from "classnames";
import * as moment from "moment";
import * as React from "react";
import Helmet from "react-helmet";
import * as styles from "./styles.css";
import DataLayer from "@lonelyplanet/dotcom-core/dist/containers/dataLayer";
import ArticleHeader from "../articleHeader";
import ArticleHeaderInfo from "../articleHeaderInfo";
import ArticleHeaderTitle from "../articleHeaderTitle";
import ArticleTitle from "../articleTitle";
import { RecommendedPosts } from "../recommendedPosts";
import SocialShare from "../socialShare";
import { TrendingPosts } from "../trendingPosts";
import { getImgixUrl } from "../../utils/getImgixUrl";
import { truncate } from "../../utils/truncate";
import AdLazyLoader from "backpack-ui/dist/components/adLazyLoader";
import ArticlePaginationNav from "backpack-ui/dist/components/articlePaginationNav";
import Breadcrumbs from "backpack-ui/dist/components/breadcrumbs";
import CalloutLink from "backpack-ui/dist/components/calloutLink";
import Container from "backpack-ui/dist/components/container";
import GridColumn from "backpack-ui/dist/components/gridColumn";
import GridRow from "backpack-ui/dist/components/gridRow";
import NewsArticleAuthor from "backpack-ui/dist/components/newsArticleAuthor";
import Newsletter from "backpack-ui/dist/components/newsletter";
import SocialShareContainer from "backpack-ui/dist/components/socialShareContainer";
import { Heading } from "backpack-ui/dist/components/text";
var Post = /** @class */ (function (_super) {
    __extends(Post, _super);
    function Post(props) {
        var _this = _super.call(this, props) || this;
        _this.processImages = _this.processImages.bind(_this);
        _this.processVideos = _this.processVideos.bind(_this);
        return _this;
    }
    Post.prototype.processImages = function () {
        var content = document.getElementById("theContent");
        var imageElements = Array.from(content.querySelectorAll("img"));
        if (imageElements) {
            imageElements.forEach(function (image) {
                var parent = image.parentNode;
                parent.className = styles.imgContainer;
            });
        }
    };
    Post.prototype.processVideos = function () {
        var content = document.getElementById("theContent");
        var videoElements = Array.from(content.querySelectorAll("[data-op-video-id]"));
        if (videoElements) {
            videoElements.forEach(function (video) {
                video.className += styles.videoElementContainer;
                video.children[0].className += cn(" videoElement", styles.videoElement);
            });
        }
    };
    Post.prototype.componentDidMount = function () {
        this.processImages();
        this.processVideos();
    };
    Post.prototype.render = function () {
        var _a = this.props, post = _a.post, recommendedPosts = _a.recommendedPosts, trendingPosts = _a.trendingPosts, next = _a.next, previous = _a.previous;
        var postContent = post.content
            // tslint:disable-next-line:max-line-length
            .replace(/stable\.web\.blog-backend\.(qa|staging|production)\.lonelyplanet\.com\/wp-content\/uploads\//g, "lonelyplanetimages.imgix.net/blog/$1/")
            .replace(/media\.lonelyplanet\.com\/blog\/(qa|staging|production)\//g, "lonelyplanetimages.imgix.net/blog/$1/")
            .replace(/\.png/g, "\.png?auto=format&q=90")
            .replace(/\.jpg/g, "\.jpg?auto=format&q=90");
        return (React.createElement("div", { className: "post" },
            React.createElement(DataLayer, { data: {
                    cd7_Topic: "blog",
                    page_type: "blog-post-page",
                    site_section: "blog",
                } }),
            React.createElement(Helmet, null,
                React.createElement("title", null, post.title + " – Lonely Planet's travel blog"),
                React.createElement("meta", { name: "title", content: post.title + " – Lonely Planet's travel blog" }),
                React.createElement("meta", { name: "description", content: post.excerpt ?
                        post.excerpt :
                        // tslint:disable-next-line:max-line-length
                        "Get a behind-the-scenes look at all things Lonely Planet on the Unpacked blog, where you'll find the stories behind the passport stamps. We share travel tips, tales and opinion pieces from our community, as well as competitions, quizzes, social media highlights and more!" }),
                React.createElement("meta", { name: "keywords", 
                    // tslint:disable-next-line:max-line-length
                    content: "Travel Guides, Guidebooks, Travel Advice, Travel Community, Groups, Profiles, Thorn Tree, Travelers, Travel Forum, Forum, friends, travel buddies, travel stories, humor, funny, Information, Tips, Destinations, Inspire, Inspiration, Visit, World, Cities, Health, Trips, Visas, Accommodation, Hotels, Flights, Car Hire, Insurance, Travel Gear, Cheap, Photography, Lonely Planet, Lonely Planet" }),
                React.createElement("meta", { property: "og:title", content: post.title + " – Lonely Planet's travel blog" }),
                React.createElement("meta", { property: "og:description", content: post.excerpt ?
                        post.excerpt :
                        // tslint:disable-next-line:max-line-length
                        "Get a behind-the-scenes look at all things Lonely Planet on the Unpacked blog, where you'll find the stories behind the passport stamps. We share travel tips, tales and opinion pieces from our community, as well as competitions, quizzes, social media highlights and more!" }),
                React.createElement("meta", { property: "og:image", content: post.featuredImage ?
                        post.featuredImage.url :
                        "https://lonelyplanetstatic.imgix.net/blog/masthead_background_image.jpg?w=2000" }),
                React.createElement("meta", { name: "twitter:card", content: "summary_large_image" }),
                React.createElement("meta", { name: "twitter:site", content: "@lonelyplanet" }),
                React.createElement("script", { type: "text/javascript", async: true, src: "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit" })),
            React.createElement(AdLazyLoader, { className: "ArticleSuperzoneTop", id: "ad-superzone-top", framed: true }),
            React.createElement(Container, { className: styles.postContainer },
                React.createElement(Breadcrumbs, { links: [
                        { title: "Blog", href: "/blog" },
                        {
                            href: "/blog/" + post.id,
                            title: truncate("" + post.title, 5),
                        },
                    ] }),
                React.createElement(ArticleHeader, null,
                    React.createElement(ArticleHeaderInfo, null, post.attribution.map(function (attribute) { return (React.createElement(NewsArticleAuthor, { name: attribute.name, title: attribute.title, absoluteTime: post.publicationDate, relativeTime: moment(post.publicationDate, "YYYYMMDD").fromNow() })); })),
                    React.createElement(ArticleHeaderTitle, null,
                        React.createElement(ArticleTitle, null, post.title))),
                React.createElement(GridRow, null,
                    React.createElement(GridColumn, { className: "ArticleContent", sm: 12, md: 7, lg: 6, lgShift: 2, fluid: true },
                        React.createElement("div", { className: styles.articleContent, id: "theContent", dangerouslySetInnerHTML: { __html: postContent } }),
                        React.createElement("div", { className: cn("ArticleFooter", styles.articleFooter) },
                            React.createElement(SocialShareContainer, { text: post.title + " – Lonely Planet's travel blog ", url: "https://www.lonelyplanet.com/blog/" + moment(post.publicationDate).format("YYYY/MM/DD") +
                                    "/" + ("/" + post.metadata.slug), twitterContent: post.title + " – Lonely Planet's travel blog https://www.lonelyplanet.com/blog/"
                                    + moment(post.publicationDate).format("YYYY/MM/DD") + "/"
                                    + ("/" + post.metadata.slug) +
                                    " via @lonelyplanet", headingText: "Share this article:", via: "lonelyplanet" }, SocialShare))),
                    React.createElement(GridColumn, { className: "ArticleSidebar", sm: 12, md: 4, mdShift: 1, lg: 3, lgShift: 1, includeGutter: true, fluid: true },
                        React.createElement(AdLazyLoader, { className: "ArticleSidebarAd", id: "ad-article-right-rail", framed: true }),
                        React.createElement("div", { className: cn("trendingArticles", styles.trendingArticles) },
                            React.createElement(Heading, { className: styles.trendingHeading, level: 6, size: 8 }, "Trending"),
                            React.createElement(TrendingPosts, { posts: trendingPosts }),
                            React.createElement(CalloutLink, { href: "/blog/category/trending", style: { marginTop: "40px" } }, "More trending"))))),
            React.createElement(AdLazyLoader, { className: cn("ArticleSuperzoneBottom", styles.bottomAd), id: "ad-superzone-bottom", framed: true }),
            React.createElement(Container, null,
                React.createElement(GridRow, null,
                    React.createElement(GridColumn, { className: cn("moreArticles", styles.moreArticles), sm: 12, fluid: true },
                        React.createElement("header", { className: styles.header },
                            React.createElement(Heading, { className: styles.heading, level: 2, weight: "light" },
                                "More in ",
                                post.categories[0].name)),
                        React.createElement(RecommendedPosts, { posts: recommendedPosts })))),
            React.createElement(Newsletter, { captchaSiteKey: "6LegewcUAAAAAG-5-ZTtWJ9M8cUyz7Mh0-uzNbC_" }),
            React.createElement("div", { className: "PaginationNav" }, previous && next && (React.createElement(ArticlePaginationNav, { previousArticle: {
                    category: "" + previous.categories[0].name,
                    href: "/blog/" + moment(previous.publicationDate).format("YYYY/MM/DD") + ("/" + previous.metadata.slug),
                    image: getImgixUrl(previous.featuredImage ?
                        previous.featuredImage.url + "?auto=format&fit=crop&w=700&h=500&q=72" :
                        // tslint:disable-next-line:max-line-length
                        "https://lonelyplanetstatic.imgix.net/marketing/global/blog_comingsoon.jpg?fit=crop&w=700&h=500&q=72"),
                    imageAlt: "" + previous.title,
                    title: "" + previous.title,
                }, nextArticle: {
                    category: "" + next.categories[0].name,
                    href: "/blog/" + moment(next.publicationDate).format("YYYY/MM/DD") + ("/" + next.metadata.slug),
                    image: getImgixUrl(next.featuredImage ?
                        next.featuredImage.url + "?auto=format&fit=crop&w=700&h=500&q=72" :
                        // tslint:disable-next-line:max-line-length
                        "https://lonelyplanetstatic.imgix.net/marketing/global/blog_comingsoon.jpg?fit=crop&w=700&h=500&q=72"),
                    imageAlt: "" + next.title,
                    title: "" + next.title,
                } })))));
    };
    return Post;
}(React.Component));
export { Post };



//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/components/post/index.tsx
// module id = +2P6
// module chunks = 3